<template>
  <v-app>
    <template v-if="route.meta.publicPage">
      <router-view />
    </template>
    <template v-else>
      <Sidebar />
      <Header />
      <v-main class="grey lighten-1">
        <router-view />
      </v-main>
      <Footer />
    </template>

    <!-- ✅ Global dialog mounted once -->
    <GlobalDialog />

    <!-- Tours disabled - available in SystemUtils prototype page -->
    <!-- <SimpleTour /> -->
    <!-- <IntroTour /> -->
  </v-app>
</template>

<script setup>
import { onBeforeUnmount, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import GlobalDialog from "@/components/GlobalDialog.vue";
const route = useRoute();
const router = useRouter();
const showSubscriptionStatus = () => {
  if (route.name !== 'CustomerDetails') router.push({ name: 'AdminStart' });
};
onMounted(() => window.addEventListener('ww-subscription-access-blocked', showSubscriptionStatus));
onBeforeUnmount(() => window.removeEventListener('ww-subscription-access-blocked', showSubscriptionStatus));
// Tours disabled - available in SystemUtils prototype page
// import SimpleTour from "@/components/SimpleTour.vue";
// import IntroTour from "@/components/IntroTour.vue";
</script>
